module.exports = __webpack_public_path__ + "img/wenzi2.cc93f7df.webp";